module.exports = __webpack_public_path__ + "img/send.5e08a2e8.svg";